<ng-container *ngIf="control">
  <ng-container *ngFor="let section of field.config.sections; let i = index">
    <label class="mb-2 block" *ngIf="section.label">{{ section.label }}</label>

    <div class="card" [ngClass]="{'mb-3': i < field.config.sections.length - 1}"   [attr.data-field]="field?.fieldUuid"
  [attr.data-typeId]="field?.config?.typeId">
      <div class="card-content">
        <div class="flex flex-row flex-wrap">
          <div class="w-1/2" *ngFor="let item of section.items; let i = index">
            <label class="flex items-start pr-3" [ngClass]="{'mb-3': i < section.items.length - 2 }">
              <input type="checkbox" class="form-checkbox mt-0 cursor-pointer shrink-0"
                     [attr.tabIndex]="0"
                     [formControl]="asFormGroup(control.controls[section.section_uuid]).controls[keys(item)[0]]">
              <span class="ml-2 mr-1 min-w-0">{{ item[keys(item)[0]]}}</span>
              <span *ngIf="isOptional(item)"
                    class="shrink-0 self-center whitespace-nowrap text-[10px] leading-none font-bold uppercase tracking-wide px-2 py-1 rounded-full bg-orange text-white"
                    i18n>opcija</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
